module.exports = __webpack_public_path__ + "media/images/news-placeholder-80193341.svg";